<template>
  <div class="findPassword">
    <div class="container">
      <form action="" class="fm">
        <h3>忘记密码</h3>
        <div class="item">
          <span>手机号</span>
          <input type="tel" placeholder="请输入登录账户" v-model="info.mobile">
        </div>
        <div class="item">
          <span>图形验证码</span>
          <input type="text" placeholder="请输入图形验证码" v-model="info.vxOpenId">
        </div>
        <div class="pic">
          <img :src="codeImg" alt="">
          <div class="mathCode">
            <p>请把左边验证码输入框中</p>
            <p class="refresh" @click="getCode">看不清，换一张</p>
          </div>
        </div>
        <div class="item">
          <span>验证码</span>
          <input type="text" placeholder="请输入验证码" v-model="info.code">
          <button :disabled="!rightPhone" class="codeBtn" :class="{right: rightPhone}" @click="send">{{computeTime ? `${computeTime}秒后重新获取` : '获取验证码'}}</button>
        </div>
        <div class="item">
          <span>密码</span>
          <input type="text" placeholder="请输入密码" v-model="info.pwd" v-if="bool">
          <input type="password" placeholder="请输入密码" v-model="info.pwd" v-else>
          <img src="../../assets/images/login/close.png" alt="" @click="open" v-if="bool">
          <img src="../../assets/images/login/open.png" alt="" @click="open" v-else>
        </div>
        <div class="item">
          <span>确认密码</span>
          <input type="text" placeholder="请确认密码" v-model="info.pwd2" v-if="bool2">
          <input type="password" placeholder="请确认密码" v-model="info.pwd2" v-else>
          <img src="../../assets/images/login/close.png" alt="" @click="open2" v-if="bool2">
          <img src="../../assets/images/login/open.png" alt="" @click="open2" v-else>
        </div>
        <button class="btn" @click="commit">提交</button>
      </form>
    </div>
  </div>
</template>

<script>
import '../../assets/css/login.less'
import {reqSend, reqResetPwd} from '../../api'
import {pwd} from '../../utils/phone'
export default {
  data () {
    return {
      info: {
        mobile: '',
        vxOpenId: '', // 图形验证码
        code: '',
        pwd: '', // 新密码
        pwd2: '', // 确认密码
      },
      codeImg: '', // 图形验证码图片
      computeTime:0 , // 计时时间
      bool: false,
      bool2: false
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    //获取图形验证码
    getCode () {
      this.codeImg = 'http://app.yixian-express.com/api/pictureCode/out?'+Math.random()
    },
    // 发送短信验证码
    send () {
      if(this.info.vxOpenId){
        if(!this.computeTime){
          //  异步发送验证码
          const data = `?mobile=${this.info.mobile}&type=RESETPWD&code=${this.info.vxOpenId}`
          reqSend (data).then(res => {
            if(res.code === 200){
              this.computeTime = 60
              const timer = setInterval(() => {
                this.computeTime --
                if(this.computeTime <= 0){
                  clearInterval(timer)
                }
              },1000)
            }else if(res.code === 500){
              this.$message({
                type:'error',
                message:res.data.errMsg
              })
            }
          })
        }
      }else{
        this.$message({
          message: '请先输入图形验证码',
          type: 'error'
        })
      }
    },
    // 提交信息
    commit () {
      const {mobile, code, pwd, pwd2} = this.info
      if(!mobile){
        this.$message({
          message: '手机号不能为空',
          type: 'error'
        })
      } else if(!code) {
        this.$message({
          message: '短信验证码不能为空',
          type: 'error'
        })
      } else if(!pwd) {
        this.$message({
          message: '密码不能为空',
          type: 'error'
        })
      }  else if(pwd2 !== pwd) {
        this.$message({
          message: '两次密码不一致',
          type: 'error'
        })
      } else {
        let query = `?mobile=${mobile}&code=${code}&pwd=${pwd}`
        reqResetPwd(query).then(res => {
          if(res.code === 200){
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.$router.replace('/login')
          }
        })
      }
    },
    open () {
      this.bool = !this.bool
    },
    open2 () {
      this.bool2 = !this.bool2
    }
  },
  computed: {
    //监听手机号是否正确
    rightPhone () {
      return /^1[3456789]\d{9}$/.test(this.info.mobile)
    },
  }
}
</script>

<style scoped lang="less" type="text/less">
  .findPassword{
    margin-top:50px;
    .btn{
      width: 100%;
      height: 54px;
      margin-top: 40px;
      margin-bottom: 60px;
      background: #2FA1DE;
      color: #fff;
      border-radius: 27px;
      font-size: 18px;
      border: none;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login/FindPassword.vue